<template>
	<div>
		<v-layout row class="mb-5">
			<v-flex xs12 sm12 md6>
				<p class="hidden-xs-only ml-4 mr-4 mt-5 add-event-step-header-big">Now, let's add your location...</p>
				<p class="hidden-sm-and-up ml-4 mr-4 mt-3 add-event-step-header-big">Now, let's add your location...</p>
				<p class="ml-4 mr-4 mb-3 mt-2 add-event-step-sub-header">
					We can't wait to learn about your spot... and to help you share it in the best way possible.
				</p>
				<p class="ml-4 mr-4 mb-3 mt-2 add-event-step-sub-header">Afterward, you can create &amp; host events at this spot.</p>
				<p class="ml-4 mr-4 mb-3 mt-2 add-event-step-sub-header">
					Please let us know if we can be of assistance!
				</p>
			</v-flex>

			<v-flex xs12 md4 offset-md1 hidden-sm-and-down class="pt-3">
				<v-card class="add-event-tip-box">
					<v-card-text class="p-relative pt-5">
						<div class="info-trapezoid p-absolute">
							<div class="info-content">
								<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
							</div>
						</div>
						<p class="add-event-tip-title">Need help?</p>
						<p class="add-event-tip-content">That’s what we’re here for!</p>
						<p class="add-event-tip-content">Please don’t hesitate to contact us for assistance or questions.</p>
						<p class="text-xs-center add-event-tip-content"><strong>support@wrkprty.com</strong></p>
						<p class="text-xs-center"><a href="tel:209-975-7789"><i class="fa fa-phone"></i>&nbsp;(209) 975-7789</a></p>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
		<v-dialog scrollable v-model="infoDialog">
			<v-card style="width: 100%">
				<v-card-title class="mb-0 pb-2 pt-3">
					<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
				</v-card-title>
				<v-card-text style="max-height:50vh;">
					<p class="add-event-tip-title">Need help?</p>
					<p class="add-event-tip-content">That’s what we’re here for!</p>
					<p class="add-event-tip-content">Please don’t hesitate to contact us for assistance or questions.</p>
					<p class="text-xs-center add-event-tip-content"><strong>support@wrkprty.com</strong></p>
					<p><a href="tel:209-975-7789"><i class="fa fa-phone"></i>&nbsp;(209) 975-7789</a></p>
				</v-card-text>
				<v-card-actions>
					<v-spacer>
					</v-spacer>
					<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
	name: 'location-start',
	methods: {
		...mapActions(['setAddLocationProp', 'setAddLocationValidStep'])
	},
	beforeRouteLeave(to, from, next) {
		this.setAddLocationValidStep(from.path)
		next()
	},
	computed: {
		...mapGetters(['getAddLocationProp']),
		infoDialog: {
			get() {
				return this.getAddLocationProp('infoDialog')
			},
			set(val) {
				this.setAddLocationProp({ prop: 'infoDialog', value: val })
			}
		}
	}
}
</script>

<style>
</style>
